<!-- template v.1 -->
<template>
<div class="col py-3 col-md-10">
            <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
              <h4 class="card-title" style="text-decoration:underline">Carga Masiva de Nuevos Empleados </h4>
              <span style="font-size: 20px;">{{Nombres}}</span>
            </div>

            <!--Inicio-->
            <div class="col-md-12" style="padding:0">
                <!-- Profile Image -->
                <div class="card card-info">
                <div class="card-header">
                    <h3 class="card-title">Leyenda</h3>
                    
                </div>
                <div class="card-body" style="padding-top:18px">
                        <div class="col-md-12">
                    
                            <div>
                            

                                <div class="col-row">

                                    <div class="col-md-12">
                                        <div class="col-md-6 form-org">
                                            <div class="form-group" style="margin-top: 15px;">
                                                <label class="col-form-label" >
                                                    Genero</label
                                                >
                                                <select class="form-control"  >
                                                    <option value="-1" >Ver </option>
                                                    <option v-for="item in genero" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                                                    
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-org">
                                            <div class="form-group" style="margin-top: 15px;">
                                                <label class="col-form-label" >
                                                    Local</label
                                                >
                                                <select class="form-control"  >
                                                    <option value="-1" >Ver </option>
                                                    <option v-for="item in local" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                                                    
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-12">
                                        <div class="col-md-6 form-org">
                                            <div class="form-group" style="margin-top: 15px;">
                                                <label class="col-form-label" >
                                                    Área</label
                                                >
                                                <select class="form-control"  >
                                                    <option value="-1" >Ver </option>
                                                    <option v-for="item in area" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                                                    
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-org">
                                            <div class="form-group" style="margin-top: 15px;">
                                                <label class="col-form-label" >
                                                    Tipo HE</label
                                                >
                                                <select class="form-control" ref="seleccionado" >
                                                    <option value="-1" >Ver </option>
                                                    <option v-for="item in tipoHE" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                                                    
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                

                            
                            </div>
                        </div>
                    
                </div>

                <!-- /.card-body -->
                </div>

            </div>
            <!--Fin-->
            <div class="col-md-12" style="padding:0; margin-top:15px;">
                <!-- Profile Image -->
                <div class="card card-info">
                <div class="card-header">
                    <h3 class="card-title">Carga de Archivo</h3>
                    
                </div>
                <div class="card-body" style="padding-top:18px">
                        <div class="col-md-12">
                    
                            <div  style="text-align:center">
                                <label class="col-form-label" style="padding:10px">Archivo TXT:</label>
                                <input
                                    type="file"
                                    placeholder="Subir Archivo"
                                    label="Subir Archivo"
                                    @change="onFileSelected"

                                    
                                    
                                />

                                <div class="col-row">

                                    <div class="col-md-12">
                                        <div class="form-group" style="margin-top: 15px;" >
                                            <button v-bind:value="file" type="submit" @click="procesar()" class="btn btn-success">
                                                Procesar
                                            </button>
                                        </div>
                                    </div>
                                </div>



                                

                            
                            </div>
                        </div>
                    
                </div>

                <!-- /.card-body -->
                </div>

            </div>

</div>


<ModalGrande v-show="ModalGrande.isLecturaMasiva" :modalgrande="ModalGrande">  
    
    
    <div class="col-md-12 form-org">

        <input type="hidden" v-model="nNroOperacion" >

        <div class="row mb-3">
            <h6>Total: {{nTotal}}</h6> 
            <h6>Correctos: {{nCorrect}}</h6>
            <h6>Error: {{nError}}</h6>
        </div>

         <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                        <th >Código Sap</th>
                        <th >Nombres</th>
                        <th >DNI</th>
                        <th >Género</th>
                        <th >Fecha Nacimiento</th>
                        <th >Fecha Ingreso</th>
                        <th >Área</th>
                        <th >Local</th>
                        <th >HHEE</th>
                        <th >Correo</th>
                        <th >Validación del Sistema</th>
         

                   
                     
                    </tr>
                  </thead>
                  
                   <tbody v-for="(item, index) in listaEmpleados"   v-bind:key="item" v-bind:index="index" >
                    <tr >
                   
                        <td >{{item.nCodigo}}</td>
                        <td >{{item.sNombre}}</td>
                        <td >{{item.sDni}}</td>
                        <td >{{item.sGenero}}</td>
                        <td >{{item.sFechaNac}}</td>
                        <td >{{item.sFechaIng}}</td>
                        <td >{{item.sArea}}</td>
                        <td >{{item.sLocal}}</td>
                        <td >{{item.sTipoHE}}</td>
                        <td >{{item.sCorreo}}</td>
                        <td >{{item.sEstado}}</td>

                    </tr>

                    
                  </tbody>

        </table>

        <div class="row">
            <div class="contenedor-botones">
                <div class="padding-btn" v-if="nGuardar != 0">
                   <button type="submit" 
                   class="btn btn-success" 
                   @click="Guardar()" >
                   
                        Guardar
                   </button>
                </div>

                <div class="padding-btn" >
                   <button type="submit" 
                   class="btn btn-danger" 
                   @click="Cancelar()" >
                   
                   Cancelar</button>
                </div>
            </div>
        </div>
               
    </div>
</ModalGrande>

<div class="overlay-wrapper"  v-if="load">
        <div class="overlay" style="flex-direction: column;">
            <i class="spinner-border"></i>
            <div class="text-bold pt-2">Cargando...</div>
        </div>
    </div>
</template>
<script>
export default {
     props: ["content"],

  data: function () {
    return {

        load: false,
        listEmpleados: [],
        cargarCombos: [],
        Areas:[],
        Area:-1,
        Empleado:this.$route.query.id,
        Nombres:this.$route.query.nombre,

        ModalGrande : {
            isLecturaMasiva : false,
        },
        genero: [],
        local:[],
        area:[],
        tipoHE: [],
        file: [],
        nNroOperacion: 0,
        nTotal: 0,
        nCorrect: 0,
        nError: 0,
        nGuardar: 0,

      
    };
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;

    this.axios
        .get(gestion + "/CargarExcel/Combos", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.cargarCombos = response.data.oListaParametros;

            this.genero = this.cargarCombos.filter(word => word.nCodigo==1);
            this.area = this.cargarCombos.filter(word => word.nCodigo==2);
            this.local = this.cargarCombos.filter(word => word.nCodigo==3);
            this.tipoHE = this.cargarCombos.filter(word => word.nCodigo==4);


            //console.log(this.genero);
          
        })

    this.axios
        .get(gestion + "/ListarLocales?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Locales = response.data.oListaLocales;
        })

    this.axios
        .get(gestion + "/ListarAreas?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Areas = response.data.oListaAreas;
        })

    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=7", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Marcaciones = response.data.oListaParametros;
        })
    
    
    
  },
  methods: {
      CargaReloj(){
        const Reloj = this.Local;
        let gestion = this.$store.state.menu;
        this.axios
            .get(gestion + "/ListarRelojes?nCodigo="+ Reloj, {
            headers: {
                Authorization: "Bearer " + localStorage.token,
            },
            })
            .then((response) => {
            this.Relojes = response.data.oListaRelojes;
            })
        },
        onFileSelected (event) {
               const file = event.target.files[0];
               //console.log(file);
               this.file = file;
               
        },
        procesar(){

            //console.log("procesando")
            //console.log(this.file);

            var file = this.file;
            //console.log(file);
           
            
            

            const bodyFormData = new FormData();
               bodyFormData.append("file", file);

               let gestion = this.$store.state.menu;

               this.axios.post(gestion + "/CargarExcel/Leer", bodyFormData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                        "Content-Type": "multipart/form-data",
                    }
                    })
                    .then((response) => {
                        //console.log(response.data);

                        this.listaEmpleados=response.data.oListaEmpleados;
                        
                        this.cabecera = response.data.oCabecera;

                        this.nNroOperacion=this.cabecera.nNroOperacion;
                        this.nTotal=this.cabecera.nTotal;
                        this.nCorrect=this.cabecera.nCorrect;
                        this.nError=this.cabecera.nError;
                        this.nGuardar=this.cabecera.nGuardar;
                        
                        const data_res = response.data.oResult.satisfactorio;
                        
                        if (data_res == true) { 

                            this.ModalGrande.isLecturaMasiva=true;
                            this.ModalGrande.titulo = 'Lectura del Formato Crear';
        

                        }
                        else {

                            this.ModalGrande.isLecturaMasiva=false;
                            this.$swal({
                            toast: true,
                            timer:3000,
                            position: 'top',
                            showConfirmButton: false,
                            title: response.data.oResult.message,
                            icon: 'error',
                            
                            });  
                        }
                        
                        
                    });

            
        },
        Guardar(){
            var nOperacion = this.nNroOperacion;
            console.log(nOperacion);

             const bodyFormData = new FormData();
               bodyFormData.append("nOperacion", nOperacion);

               let gestion = this.$store.state.menu;

               this.axios.post(gestion + "/CargarExcel/TransferirNuevo", bodyFormData, {
                    headers: {
                        Authorization: "Bearer " + localStorage.token,
                        "Content-Type": "multipart/form-data",
                    }
                    })
                    .then((response) => {
                        //console.log(response);
                        
                        const data_res = response.data.satisfactorio;
                        
                        if (data_res == true) { 

                            this.$swal({
                                toast: true,
                                timer:3000,
                                position: 'top',
                                showConfirmButton: false,
                                title: response.data.message,
                                icon: 'success',
                                
                            });  

                            this.ModalGrande.isLecturaMasiva=false;
        

                        }
                        else {
                            this.$swal({
                            toast: true,
                            timer:3000,
                            position: 'top',
                            showConfirmButton: false,
                            title: response.data.message,
                            icon: 'error',
                            
                            });  
                        }
                        
                        
                    });


        },
        Cancelar(){
            this.ModalGrande.isLecturaMasiva =false;
        }
        

  },
}
</script>
<style scoped>
.btn-table{
    margin: 0 5px;

}

.contenedor-botones{
	display: flex;
    justify-content: center;
    align-items: center;
}

.padding-btn{
    padding: 10px;
}

</style>
